<section *ngIf="reviewList.length > 0"
		 class="flex flex-col lg:px-10 my-2 lg:my-6">
	<ng-container *ngFor="let review of reviewList">
		<fb-review-preview-card [review]="review"></fb-review-preview-card>
		<hr class="my-4">
	</ng-container>

	<div class="flex justify-center">
		<button *ngIf="productId !== 0"
				(click)="onViewAll()"
				class="w-[100px] rounded-xl text-white bg-[#6c5b48] px-2.5 py-1">View All</button>
		<button *ngIf="productId === 0"
				(click)="onViewMore()"
				class=" w-[100px] rounded-xl text-white bg-[#6c5b48] px-2.5 py-1">View More </button>
	</div>
</section>
